import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import { Button, Grid } from '@mui/material';

export default function Search({ onSubmit, loading }) {
  const [id, setId] = React.useState('3254');

  return (
    <Container className='page'>
      <Box className='section' sx={{ marginTop: 2 }}>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            '& > :not(style)': { m: 1, width: '25ch' },
          }}
          onSubmit={(e) => {
            console.log(id);
            e.preventDefault();
            onSubmit(id);
          }}
        >
          <Grid container spacing={2} alignItems="left" justifyContent="left">
            <Grid item>
              <TextField
                id="outlined-basic"
                label="Ingresa el ID de Consulta"
                variant="outlined"
                value={id}
                onChange={(e) => setId(e.target.value)}
              />
            </Grid>
            <Grid item>
              <Button type="submit" variant="contained" disabled={loading}>
                {loading ? 'Cargando...' : 'Buscar'}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  )
}